import {
  APP_BASE_HREF,
  isPlatformBrowser,
  LocationStrategy,
  PathLocationStrategy,
  PlatformLocation,
} from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { SettingsService } from './settings.service';

/**
 * When navigating between routes, it sets and maintains the settings query parameters.
 * This is particularly important to avoid user refreshing a page and losing all the settings (e.g. tagID, viewMode, campaignId, etc)
 */
@Injectable()
export class PreserveQueryParamsStrategy
  extends PathLocationStrategy
  implements LocationStrategy
{
  constructor(
    private settingsService: SettingsService,
    platformLocation: PlatformLocation,
    @Optional() @Inject(APP_BASE_HREF) baseHref?: string
  ) {
    super(platformLocation, baseHref);
  }

  prepareExternalUrl(internal: string): string {
    const path = super.prepareExternalUrl(internal);

    const pathQueryIndex = path.indexOf('?');

    const queryParams =
      pathQueryIndex >= 0
        ? new URLSearchParams(path.slice(pathQueryIndex + 1))
        : new URLSearchParams();
    const settingsQueryParams = this.settingsService.toQueryParams().entries();

    for (let [key, value] of settingsQueryParams) {
      queryParams.set(key, value);
    }

    const pathWithoutQuery =
      pathQueryIndex === -1 ? path : path.slice(0, pathQueryIndex);

    return `${pathWithoutQuery}?${queryParams.toString()}`;
  }
}
